/* полифиллы тут в билд запихнутся сами, руками этот файл никуда импортировать не надо */
import 'core-js/actual/array/some';
import 'core-js/actual/global-this';
import 'resize-observer-polyfill/dist/ResizeObserver.global';
